var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2 30.4H3.79999V0H6.45999V27.74H34.2V30.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2 26.4735H26.22V0H34.2V26.4735ZM28.88 23.8135H31.54V2.66H28.88V23.8135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9535 26.4735H16.9735V6.58649H24.9535V26.4735ZM19.6335 23.8135H22.2935V9.24649H19.6335V23.8135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7065 26.4735H7.72647V13.1735H15.7065V26.4735ZM10.3865 23.8135H13.0465V15.8335H10.3865V23.8135Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsWhite);
export default __webpack_public_path__ + "static/media/analytics-white.a409a3cfdf7be7a805b06cfff54de426.svg";
export { ForwardRef as ReactComponent };